import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SystemColorInputComponent } from '@components/system-color/system-color-input/system-color-input.component';
import { SystemColorValidator } from '@models/models-validators/system-color-validator';
import { SystemColorService } from '@service/system-color.service';
import { SystemColor, SystemColorType } from 'icreate/common/models/system-color';
import { getValidationErrors, mapErrors, ValidationErrorMap } from 'icreate/common/validators';

enum SystemColorInputName {
    COLOR_ASSIGNMENT = 'color-assignment',
}

export enum SystemColorDialogMode {
    edit = 'edit',
    default = 'default',
}

@Component({
    selector: 'app-new-system-color-dialog',
    templateUrl: './new-system-color-dialog.component.html',
    styleUrls: ['./new-system-color-dialog.component.css'],
    standalone: false,
})
export class NewSystemColorDialogComponent {
    readonly COLOR_ASSIGNMENT = SystemColorInputName.COLOR_ASSIGNMENT;

    @ViewChild('systemColorInput') systemColorInput: SystemColorInputComponent;

    validationErrors: ValidationErrorMap = {};

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            id?: string;
            vesselId: string;
            name: string;
            color: string;
            type: SystemColorType;
            isEditable: boolean;
            mode: string;
            systemColorList: SystemColor[];
        },
        private dialogRef: MatDialogRef<NewSystemColorDialogComponent>,
        private systemColorService: SystemColorService
    ) {}

    ngOnInit() {
        this.getErrors();
    }

    onInputChange(event) {
        if (this.COLOR_ASSIGNMENT === event.name) {
            this.data.name = event.value;
        }

        this.getErrors();
    }

    isConfirmDisabled() {
        return this.systemColorInput?.rgbErrorMessage || !this.data.color || this.validationErrors.name?.message;
    }

    getErrors() {
        const errors = getValidationErrors(SystemColorValidator(), {
            name: this.data.name,
            color: this.data.color,
        });

        this.validationErrors = mapErrors(errors);

        if (!this.validationErrors?.name) {
            const isDuplicate = this.data.systemColorList?.some(
                systemColor => systemColor.name === this.data.name && this.data.id != systemColor.id
            );
            if (isDuplicate) {
                this.validationErrors.name = {
                    message: 'common.error.name-duplicate',
                };
            }
        }
    }

    handleColorChange(color) {
        this.data.color = color;
    }

    cancelClick() {
        this.dialogRef.close();
    }

    async createButtonClick() {
        try {
            if (this.data.mode) {
                await this.systemColorService.update(this.data);
            } else {
                await this.systemColorService.create(this.data);
            }
        } catch (error) {
            console.log(error);
        }
        this.cancelClick();
    }
}
